import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

interface Props {
    label?: string;
    date?: string | null;
    onDateInputChange?: (date: Dayjs | null) => void;
    error?: {
        message?: string;
    };
    required?: boolean;
    inputFormat?: string;
}

const PortalDatePicker = (props: Props) => {
    const { label, date, onDateInputChange, required, inputFormat } = props;
    const [value, setValue] = React.useState<Dayjs | null>(date ? dayjs(date) : null);

    const handleChange = (newValue: Dayjs | null) => {
        setValue(newValue);
        if (onDateInputChange) {
            onDateInputChange(newValue);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label || 'Date Picker'}
                format={inputFormat || 'DD/MM/YYYY'}
                onChange={handleChange}
                value={value}
                slotProps={{
                    textField: {
                        helperText: props.error?.message,
                        error: props.error ? true : false,
                        required: required,
                        fullWidth: true
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export default PortalDatePicker;
